export enum ConversationChannel {
  Website = 1,
  Email = 2,
  Sms = 3,
  WhatsApp = 4,
}
